module.exports = __webpack_public_path__ + "static/img/laborMin.7efea94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/laborMin.jpg
// module id = Bwr1
// module chunks = 0